import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=a3287674"
import script from "./salesman.vue?vue&type=script&lang=js"
export * from "./salesman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports